import { render } from "./ProfileHead.vue?vue&type=template&id=a7102adc"
import script from "./ProfileHead.vue?vue&type=script&lang=js"
export * from "./ProfileHead.vue?vue&type=script&lang=js"
script.render = render

export default script